// src/config/navigation.js

export const menuItems = {
  // INVENTARIO
  inventory: {
    feature: 'IN',
    icon: 'mdi-archive-outline',
    title: 'Inventario',
    items: [
      {
        title: 'Gestión de productos',
        icon: 'widgets',
        feature: 'IN',
        children: [
          {
            title: 'Productos y servicios',
            icon: 'local_mall',
            to: { name: 'Articles' }
          },
          {
            title: 'Conversiones',
            icon: 'transform',
            feature: 'INV-03',
            to: { name: 'ArticleConversions' }
          },
          {
            title: 'Inventario',
            icon: 'rule',
            feature: 'INV-01',
            to: { name: 'InventoryManagement' }
          },
          {
            title: 'Salidas de inventario',
            icon: 'autorenew',
            feature: 'INV-14',
            to: { name: 'Departures' }
          },
          {
            title: 'Ajustes',
            icon: 'autorenew',
            feature: 'INV-04',
            to: { name: 'Adjustments' }
          },
          {
            title: 'Combos',
            icon: 'repeat',
            feature: 'INV-16',
            to: { name: 'ComboTransformation' }
          },
          {
            title: 'Transferencias',
            icon: 'sync_alt',
            feature: 'INV-05',
            to: { name: 'TransferRequest', params: { type: 1 } }
          },
          {
            title: 'Movimientos',
            icon: 'fork_right',
            feature: 'INV-15',
            to: { name: 'MovementBtLocations' }
          },
          {
            title: 'Aprobaciones',
            icon: 'task_alt',
            feature: 'INV-06',
            to: { name: 'Approvals' }
          },
          {
            title: 'Recepción',
            icon: 'archive',
            feature: 'INV-07',
            to: { name: 'TransferReceivedt', params: { type: 2 } }
          }
        ]
      },
      {
        title: 'Activos fijos',
        icon: 'loyalty',
        feature: 'INV-08',
        to: { name: 'Assets' }
      },
      {
        title: 'Almacenes',
        icon: 'store',
        feature: 'INV-09',
        to: { name: 'Warehouse' }
      },
      {
        title: 'Categorías',
        icon: 'category',
        feature: 'INV-10',
        to: { name: 'Category' }
      },
      {
        title: 'Catálogos',
        icon: 'view_list',
        feature: 'INV-11',
        to: { name: 'Catalogue' }
      },
      {
        title: 'Variantes',
        icon: 'checklist_rtl',
        feature: 'INV-12',
        to: { name: 'Variant' }
      },
      {
        title: 'Reportes',
        icon: 'mdi-chart-bar',
        feature: 'INV-01',
        children: [
          {
            title: 'Salidas / Entrada',
            icon: 'mdi-swap-horizontal',
            feature: 'INV-01',
            to: { name: 'InventoryInOutReport' }
          }
        ]
      }
    ]
  },


  // INGRESOS
  income: {
    feature: 'ING',
    icon: 'mdi-hand-coin-outline',
    title: 'Ingresos',
    items: [
      {
        title: 'Cotizaciones',
        icon: 'request_quote',
        feature: 'ING-01',
        to: { name: 'Quote' }
      },
      {
        title: 'Factura de venta',
        icon: 'receipt',
        feature: 'ING-02',
        to: { name: 'InvoiceSales' }
      },
      {
        title: 'Ordenes Kiosco',
        icon: 'mdi-basket-outline',
        feature: 'ING-03',
        to: { name: 'OrderSale' }
      },
      {
        title: 'Notas de crédito',
        icon: 'receipt',
        feature: 'ING-04',
        to: { name: 'CreditNotes' }
      },
      {
        title: 'Notas de débito',
        icon: 'receipt',
        feature: 'ING-04',
        to: { name: 'DebitNotesSale' }
      },
      {
        title: 'Cajas',
        icon: 'point_of_sale',
        feature: 'ING-051',
        to: { name: 'Boxes' }
      },
      {
        title: 'Descuentos',
        icon: 'local_atm',
        feature: 'ING-06',
        to: { name: 'Discount' }
      },
      // { DESHUSO
      //   title: 'Anticipo',
      //   icon: 'paid',
      //   feature: 'ING-07',
      //   to: { name: 'Prepaid' }
      // },
      {
        title: 'Ventas por productos',
        icon: 'inventory',
        feature: 'ING-08',
        to: { name: 'productSales' }
      },
      {
        title: 'Crédito empleado',
        icon: 'person_remove',
        feature: 'ING-09',
        to: { name: 'employeeCredit' }
      }
    ]
  },

  // CUENTAS POR COBRAR
  accountsReceivable: {
    feature: 'CXC',
    icon: 'add_card',
    title: 'Cuenta por cobrar',
    items: [
      {
        title: 'Cobros',
        icon: 'attach_money',
        feature: 'CXC-02',
        to: { name: 'PaymentsReceived' }
      },
      {
        title: 'Prepagos',
        feature: 'CXC-04',
        icon: 'account_balance_wallet',
        to: { name: 'DirectPayment' }
      }
    ]
  },

  // TESORERÍA
  treasury: {
    feature: 'TES',
    icon: 'mdi-cash-multiple',
    title: 'Tesorería',
    items: [
      {
        title: 'Gestión de Efectivo',
        icon: 'mdi-cash-register',
        children: [
          {
            title: 'Caja chica',
            icon: 'mdi-cash',
            disabled: true,
            to: { name: 'CashManagement' }
          },
          {
            title: 'Recepción de efectivo',
            icon: 'mdi-cash-plus',
            disabled: true,
            to: { name: 'CashReceival' }
          },
          {
            title: 'Desembolsos',
            icon: 'mdi-cash-minus',
            disabled: true,
            to: { name: 'CashDisbursement' }
          }
        ]
      },
      {
        title: 'Gestión Bancaria',
        icon: 'mdi-bank',
        children: [
          {
            title: 'Cuentas bancarias',
            icon: 'account_balance_wallet',
            to: { name: 'Banks' }
          },
          {
            title: 'Transferencias bancarias',
            icon: 'swap_horiz',
            disabled: true,
            to: { name: 'BankTransfers' }
          },
          {
            title: 'Conciliaciones bancarias',
            icon: 'assured_workload',
            to: { name: 'Conciliation' }
          }
        ]
      },
      {
        title: 'Flujo de Caja',
        icon: 'mdi-trending-up',
        children: [
          {
            title: 'Flujo actual',
            icon: 'mdi-chart-line',
            disabled: true,
            to: { name: 'CashFlow' }
          },
          {
            title: 'Proyecciones',
            icon: 'mdi-chart-timeline-variant',
            disabled: true,
            to: { name: 'CashProjections' }
          },
          {
            title: 'Presupuesto',
            icon: 'mdi-chart-donut',
            disabled: true,
            to: { name: 'CashBudget' }
          }
        ]
      },
      {
        title: 'Pagos',
        icon: 'mdi-cash-multiple',
        children: [
          {
            title: 'Programación de pagos',
            icon: 'mdi-calendar-clock',
            disabled: true,
            to: { name: 'PaymentSchedule' }
          },
          {
            title: 'Lotes de pago',
            icon: 'mdi-file-multiple',
            disabled: true,
            to: { name: 'PaymentBatch' }
          },
          {
            title: 'Autorización de pagos',
            icon: 'mdi-check-decagram',
            disabled: true,
            to: { name: 'PaymentAuthorization' }
          }
        ]
      },
      {
        title: 'Reportes',
        icon: 'mdi-file-chart',
        children: [
          {
            title: 'Posición de tesorería',
            icon: 'mdi-finance',
            disabled: true,
            to: { name: 'TreasuryPosition' }
          },
          {
            title: 'Saldos bancarios',
            icon: 'mdi-bank-check',
            disabled: true,
            to: { name: 'BankBalances' }
          },
          {
            title: 'Flujo de caja',
            icon: 'mdi-chart-areaspline',
            disabled: true,
            to: { name: 'CashFlowReport' }
          }
        ]
      }
    ]
  },

  // COMPRAS
  purchases: {
    feature: 'COM',
    icon: 'mdi-cart-outline',
    title: 'Compras',
    items: [
      {
        title: 'Solicitudes de compra',
        icon: 'add_shopping_cart',
        feature: 'SHOP-04',
        to: { name: 'PurchaseRequest' }
      },
      {
        title: 'Cotizar',
        icon: 'edit_note',
        feature: 'SHOP-05',
        to: { name: 'Quotes' }
      },
      {
        title: 'Cotizaciones',
        icon: 'list',
        feature: 'SHOP-05',
        to: { name: 'QuotesGroup' }
      },
      {
        title: 'Ordenes de compra',
        icon: 'shopping_bag',
        feature: 'SHOP-11',
        to: { name: 'PurchaseOrder' }
      },
      {
        title: 'Aprobaciones compra',
        icon: 'task_alt',
        feature: 'SHOP-14',
        to: { name: 'Approved' }
      },
      {
        title: 'Recepción ordenes',
        icon: 'archive',
        feature: 'SHOP-131',
        to: { name: 'Receptions' }
      },
      {
        title: 'Estadísticas',
        icon: 'mdi-chart-timeline-variant',
        feature: 'SHOP-118',
        to: { name: 'ShopReports' }
      },
      {
        title: 'Proyectos',
        feature: 'CON-24',
        icon: 'mdi-home-city-outline',
        to: { name: 'Projects' }
      },
      {
        title: 'Mantenimientos',
        icon: 'shopping_cart',
        feature: 'SYSFC',
        children: [
          {
            title: 'Presupuesto',
            icon: 'mdi-cash-plus',
            to: { name: 'Budget' }
          },
          {
            title: 'Proyecciones',
            icon: 'mdi-abacus',
            to: { name: 'Projections' }
          },
          {
            title: 'Solicitantes',
            icon: 'assignment_ind',
            to: { name: 'Applicants' }
          },
          // {
          //   title: 'Aprobadores',
          //   icon: 'group',
          //   to: { name: 'Approvers' }
          // },
          {
            title: 'Rutas',
            icon: 'group',
            to: { name: 'ApprovalRoutes' }
          }
        ]
      }
    ]
  },

  // CUENTAS POR PAGAR
  accountsPayable: {
    feature: 'CXP',
    icon: 'add_card',
    title: 'Cuenta por pagar',
    items: [
      {
        title: 'Pagos',
        feature: 'CXP-02',
        icon: 'add_shopping_cart',
        to: { name: 'PaymentsCxp' }
      },
      {
        title: 'Prepagos',
        feature: 'CXP-02',
        icon: 'mdi-cash-multiple',
        to: { name: 'DirectPaymentsCxp' }
      },
      {
        title: 'Transacciones',
        feature: 'CXP-01',
        icon: 'sync_alt',
        to: { name: 'TransactionsCxP' }
      },
      {
        title: 'Factura de proveedores',
        feature: 'SHOP-16',
        icon: 'receipt',
        to: { name: 'InvoiceShop' }
      },
      {
        title: 'Notas de crédito',
        feature: 'SHOP-02',
        icon: 'receipt',
        to: { name: 'CreditNoteShop' }
      },
      {
        title: 'Notas de débito',
        icon: 'receipt',
        feature: 'SHOP-17',
        to: { name: 'DebitNotes' }
      },
      {
        title: 'Prestaciones',
        feature: 'SHOP-16',
        icon: 'mdi-account-cash',
        to: { name: 'BenefitInvoices' }
      },
      {
        title: 'Secuencia cheques',
        feature: 'CXP-03',
        icon: 'account_balance',
        to: { name: 'GenerateCheck' }
      }
    ]
  },

  // CONTABILIDAD
  accounting: {
    feature: 'CON',
    icon: 'mdi-calculator-variant-outline',
    title: 'Contabilidad',
    items: [
      {
        title: 'Catálogo de cuentas',
        icon: 'account_balance_wallet',
        feature: 'CON-01',
        to: { name: 'Accounts' }
      },
      {
        title: 'Entradas de diario',
        icon: 'history_edu',
        feature: 'CON-02',
        to: { name: 'EntryDaily' }
      },
      {
        title: 'Libro diario',
        icon: 'menu_book',
        feature: 'CON-03',
        to: { name: 'DiaryBook' }

      },
      {
        title: 'DGII',
        icon: 'mdi-file-certificate',
        children: [
          {
            title: 'Documentos recibidos DGII',
            icon: 'receipt_long',
            to: { name: 'DocumentsRecivedDgii' }
          },
          {
            title: 'Aprobaciones comerciales',
            icon: 'mdi-check-decagram',
            to: { name: 'CommercialApprovals' }
          },
        ]
      },
      {
        title: 'Módulos',
        icon: 'view_module',
        feature: 'CON-14',
        to: { name: 'Modules' }
      },
      {
        title: 'Reportes',
        icon: 'mdi-chart-bar',
        children: [
          {
            title: 'Estados',
            icon: 'mdi-finance',
            feature: 'CON-04',
            to: { name: 'ReportStatus' }
          },
          {
            title: 'Balanza comprobación',
            icon: 'mdi-scale-balance',
            feature: 'CON-05',
            to: { name: 'TrialBalance' }
          },
          {
            title: 'Cuadre de afiliadas',
            icon: 'mdi-bank-transfer',

            to: { name: 'AffiliatesBalance' }
          },
          {
            title: 'DGII',
            icon: 'card_travel',

            to: { name: 'Dgii' }
          }
        ]
      },
      {
        title: 'Retenciones suplidor',
        icon: 'monetization_on',
        feature: 'CON-06',
        to: { name: 'WithholdingsSuppliers' }
      },
      {
        title: 'Cambio de moneda',
        icon: 'currency_exchange',
        feature: 'CON-07',
        to: { name: 'ChangeMoney' }
      },
      {
        title: 'Cajas a contabilidad',
        icon: 'mdi-cash-register',
        feature: 'CON-08',
        to: { name: 'BoxesToAccounting' }
      },
      {
        title: 'Nóminas a contabilizar',
        icon: 'view_module',
        feature: 'CON-09',
        to: { name: 'PayrollAccounting' }
      },
      {
        title: 'Revaluación',
        icon: 'join_inner',
        feature: 'CON-10',
        to: { name: 'RevaluatePeriods' }
      },
      {
        title: 'Comprobantes',
        icon: 'menu',
        feature: 'CON-1711',
        to: { name: 'VouchersVue' }
      },
      {
        title: 'Mantenimientos',
        icon: 'mdi-calculator-variant-outline',
        children: [
          {
            title: 'Grupo de moneda',
            icon: 'monetization_on',
            feature: 'CON-12',
            to: { name: 'GroupMoney' }
          },
          {
            title: 'Cuentas por defectos',
            icon: 'monetization_on',
            feature: 'CON-12',
            to: { name: 'AccountsSettings' }
          },
          {
            title: 'Calendario',
            icon: 'edit_calendar',
            feature: 'CON-12',
            to: { name: 'Calendar' }
          },
          {
            title: 'Cierre de año',
            icon: 'free_cancellation',
            feature: 'CON-12',//arreglar
            to: { name: 'AccountingYearClosing' }
          },
          {
            title: 'Excepción de revaluación',
            icon: 'do_not_disturb_off',
            feature: 'CON-13',
            to: { name: 'RevaluatePeriodsException' }
          },

          {
            title: 'Distribución cuentas',
            icon: 'category',
            feature: 'CON-15',
            to: { name: 'CategoryAccounts' }
          },
          {
            title: 'Métodos de Pago',
            icon: 'mdi-account-credit-card-outline',
            feature: 'CON-16',
            to: { name: 'PaymentMethods' }
          },

          {
            title: 'Retenciones',
            icon: 'front_hand',
            feature: 'CON-18',
            to: { name: 'Withholdings' }
          },
          {
            title: 'Itbis',
            icon: 'volunteer_activism',
            feature: 'CON-19',
            to: { name: 'Itbis' }
          },
          {
            title: 'Tipo cliente',
            icon: 'volunteer_activism',
            feature: 'CON-20',
            to: { name: 'CustomerType' }
          },
          {
            title: 'Tipo Suplidor',
            icon: 'volunteer_activism',
            feature: 'CON-21',
            to: { name: 'SupplierType' }
          },
          {
            title: 'Categorías DGII',
            icon: 'category',
            feature: 'CON-22',
            to: { name: 'CategoriesDGII' }
          },
          {
            title: 'Categorias y sub-categorias',
            icon: 'home',
            feature: 'CON-23',
            to: { name: 'CategoriesAccountig' }
          }
        ]
      }
    ]
  },

  // CONTACTOS
  contacts: {
    feature: 'CNN-01',
    icon: 'mdi-account-group-outline',
    title: 'Contactos',
    items: [
      {
        title: 'Todos',
        icon: 'groups',
        to: { name: 'Contacts' },
        feature: 'CNN-01'
      },
      {
        title: 'Clientes',
        icon: 'supervisor_account',
        to: { name: 'Clients' },
        feature: 'CNN-02'
      },
      {
        title: 'Suplidores',
        icon: 'engineering',
        to: { name: 'Suppliers' },
        feature: 'CNN-03'
      }
    ]
  },

  // MANTENIMIENTOS (SETTINGS)
  settings: {
    icon: 'mdi-cog-outline',
    title: 'Mantenimientos',
    feature: 'SYSFC',
    items: [

      {
        title: 'Usuarios',
        icon: 'people',
        to: { name: 'User' }
      },
      {
        title: 'Perfiles de usuarios',
        icon: 'people',
        to: { name: 'UserProfiles' }
      },
      {
        title: 'Unidad de negocios',
        icon: 'corporate_fare',
        to: { name: 'BussinesUnit' }
      },
      {
        title: 'Locations',
        icon: 'my_location',
        to: { name: 'Locations' }
      },
      {
        title: 'Departamentos',
        icon: 'apartment',
        to: { name: 'Departments' }
      },
      {
        title: 'Deducciones',
        icon: 'settings_accessibility',
        to: { name: 'Deductions' }
      },
      {
        title: 'Devengos',
        icon: 'savings',
        to: { name: 'Accurals' }
      },
      {
        title: 'Razones de ajustes',
        icon: 'mdi-format-list-bulleted-type',
        to: { name: 'AdjustmentReasons' }
      },
      {
        title: 'Provisiones de nómina',
        icon: 'mdi-account-file-text-outline',
        to: { name: 'PayrollProvisions' }
      }
    ]
  },

};

// Utilidades para filtrar items según permisos
export const filterItemsByFeature = (items, features) => {
  return items.filter(item => {
    if (!item.feature) return true;
    return features.includes(item.feature);
  });
};

// Utilidad para obtener módulos activos (sin cambios)
export const getActiveModules = (features) => {
  return Object.entries(menuItems)
    .filter(([_, module]) => !module.feature || features.includes(module.feature))
    .reduce((acc, [key, module]) => {
      acc[key] = module;
      return acc;
    }, {});
};

// Utilidad para obtener rutas disponibles según permisos (sin cambios)
export const getAvailableRoutes = (features) => {
  const routes = [];

  const processItems = (items) => {
    items.forEach(item => {
      if (item.to && (!item.feature || features.includes(item.feature))) {
        routes.push(item.to.name);
      }
      if (item.children) {
        processItems(item.children);
      }
    });
  };

  Object.values(menuItems).forEach(module => {
    if (!module.feature || features.includes(module.feature)) {
      processItems(module.items);
    }
  });

  return routes;
};

export default menuItems;
